<template>
    <div v-if="supplier">
        <page-header :title="supplier.name">
            <button class="button is-small" @click="openSupplierModal()">
                <span class="icon is-small">
                    <i class="fas fa-edit" />
                </span>
            </button>
        </page-header>

        <hr>

        <div class="columns">
            <div class="column">
                {{ supplier.address }}<br />
                {{ supplier.zipcode }} {{ supplier.city }}<br />
                {{ supplier.country ? supplier.country.name : '-' }}<br />

            </div>
            <div class="column">
                E-mail: {{ supplier.email }}<br />
                Telefon: {{ supplier.phone }}<br />
                Valuta: {{ supplier.currency }}<br />
<!--                Gruppe: {{ supplier.supplier_group_number }}<br />-->
<!--                TAX: {{ supplier.vat_zone_number }}<br />-->
<!--                Terms: {{ supplier.payment_terms_number }}-->
            </div>
        </div>

        <hr class="contacts-hr" />

        <page-header title="Produkter"></page-header>
        <p>...</p>


        <SupplierModal
            v-if="supplierModalOpen"
            :active="supplierModalOpen"
            :supplier-id="parseInt(id)"
            @closed="supplierModalClosed"
        />
    </div>
</template>

<script>
import PageHeader from '@elems/pageHeader'
import List from '@elems/list'
import SupplierModal from './SupplierModal'

export default {
    components: {
        PageHeader,
        List,
        SupplierModal,
    },
    props: {
        id: String,
    },
    data() {
        return {
            supplierModalOpen: false,
        };
    },
    computed: {
        supplier() {
            const id = parseInt(this.id, 10)

            return this.$store.getters.findSupplier(id)
        },
    },
    methods: {
        openSupplierModal() {
            this.supplierModalOpen = true
        },
        supplierModalClosed() {
            this.getLocations()
            this.closeSupplierModal()
        },
        closeSupplierModal() {
            this.supplierModalOpen = false
        },
    },
    created() {
        this.$store.dispatch('loadSuppliers')
    }
}
</script>

<style>
.contacts-hr {
    margin-top: 40px;
}
</style>
